import { createSlice } from '@reduxjs/toolkit';

import { deleteTestAction } from '../thunk/deleteTest';

const deleteTestSlice = createSlice({
  name: 'deleteTest',
  initialState: {
    data: {},
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTestAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestAction.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteTestAction.rejected, (state, action) => {
        state.error = action.payload || action.error?.message;
        state.loading = false;
      });
  },
});

export default deleteTestSlice.reducer;
